import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';
import { ValidationsService } from '../../services/validations.service';

@Directive({
  selector: '[appIbanValid]',
  providers: [{ provide: NG_VALIDATORS, useExisting: IbanValidDirective, multi: true }],
})
export class IbanValidDirective implements Validator {
  @Input('onlyDE') onlyDE: boolean = false;

  validate(control: AbstractControl): ValidationErrors | null {
    return ValidationsService.ibanValidator(this.onlyDE)(control);
  }
}
